var map = {
	"./Apeda.png": 6026,
	"./BPI.JPG": 963,
	"./BRCGS-LOGO.jpg": 8412,
	"./Chemexil.png": 9004,
	"./CoirBoard.png": 2518,
	"./Greencert-logo.png": 9786,
	"./OrganicCert.webp": 490,
	"./TUV.webp": 2574,
	"./UKcert.png": 7897,
	"./cipet.jpg": 3652,
	"./fda-certification-consultant-500x500.webp": 9814,
	"./haccp-certification-services-500x500.webp": 8057,
	"./images.jpg": 2421,
	"./labTested.jpg": 5197,
	"./makeInIndia.webp": 8265,
	"./pfas02.webp": 4079,
	"./sgs.png": 8554,
	"./what-is-iso-9001-compliance.webp": 3143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5379;